import { render, staticRenderFns } from "./ManagePots.vue?vue&type=template&id=19e5114c&"
import script from "./ManagePots.vue?vue&type=script&lang=js&"
export * from "./ManagePots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports